import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../styles/Team.module.css';

const PageSelectorModal = ({ isOpen, onClose, pages, selectedPage, setSelectedPage, onApply }) => {
  const [search, setSearch] = useState('');
  const filteredPages = pages.filter(page =>
    page.page_name.toLowerCase().includes(search.toLowerCase())
  );

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.pageSelectorModal} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>
            <FontAwesomeIcon icon="globe" />
            Select Page
          </h3>
          <button className={styles.modalCloseBtn} onClick={onClose}>
            <FontAwesomeIcon icon="times" />
          </button>
        </div>
        
        <div className={styles.pageSearchBar}>
          <div style={{ position: 'relative', width: '100%' }}>
            <FontAwesomeIcon 
              icon="search" 
              style={{ 
                position: 'absolute', 
                left: '16px', 
                top: '50%', 
                transform: 'translateY(-50%)',
                color: '#a1a1aa', 
                fontSize: '0.9rem',
                zIndex: 2,
                pointerEvents: 'none'
              }} 
            />
            <input
              className={styles.pageSearchInput}
              type="text"
              placeholder="Type to search pages..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Escape') {
                  setSearch('');
                  e.target.blur();
                }
              }}
              autoFocus
            />
            {search && (
              <button
                onClick={() => setSearch('')}
                style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  color: '#a1a1aa',
                  cursor: 'pointer',
                  padding: '4px',
                  borderRadius: '4px',
                  zIndex: 2
                }}
                onMouseEnter={e => e.target.style.color = '#ffffff'}
                onMouseLeave={e => e.target.style.color = '#a1a1aa'}
              >
                <FontAwesomeIcon icon="times" fontSize="0.8rem" />
              </button>
            )}
          </div>
        </div>
        
        <div className={styles.pageListArea} tabIndex={-1}>
          <div
            className={`${styles.pageCard} ${selectedPage === 'overall' ? styles.selected : ''}`}
            tabIndex={0}
            onClick={() => setSelectedPage('overall')}
            onKeyDown={e => { if (e.key === 'Enter') setSelectedPage('overall'); }}
            aria-selected={selectedPage === 'overall'}
            role="option"
          >
            <div className={styles.pageCardIcon}>
              <FontAwesomeIcon icon="chart-bar" />
            </div>
            <div className={styles.pageCardContent}>
              <h4>All Pages Overview</h4>
            </div>
          </div>
          {filteredPages.map(page => (
            <div
              key={page.page_id}
              className={`${styles.pageCard} ${selectedPage === page.page_id ? styles.selected : ''}`}
              tabIndex={0}
              onClick={() => setSelectedPage(page.page_id)}
              onKeyDown={e => { if (e.key === 'Enter') setSelectedPage(page.page_id); }}
              aria-selected={selectedPage === page.page_id}
              role="option"
            >
              <div className={styles.pageCardIcon}>
                <FontAwesomeIcon icon="user" />
              </div>
              <div className={styles.pageCardContent}>
                <h4>{page.page_name}</h4>
              </div>
            </div>
          ))}
          {filteredPages.length === 0 && search && (
            <div className={styles.emptyState}>
              <FontAwesomeIcon icon="search" style={{ marginRight: '8px', opacity: 0.6 }} />
              No pages found matching "{search}"
            </div>
          )}
        </div>
        <div className={styles.modalActions}>
          <button className={styles.applyBtn} onClick={onApply}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageSelectorModal; 